import { ThemeOption } from 'owa-theme-option';
import { DarkModeOption } from 'owa-dark-mode-option';
var appearanceSubCategory = {
    key: 'appAppearance',
    titleStringKey: 'optionSubcategory_appearance',
    options: [ThemeOption, DarkModeOption],
};
export default appearanceSubCategory;
//# sourceMappingURL=appearanceSubCategory.js.map